import { StrategyListItem } from 'model/modules/strategies/strategies';

const mapStrategyListFromApi = (
  api: ApiFetchStrategyListItem[]
): StrategyListItem[] => {
  return api.map((item) => ({
    id: item.id,
    title: item.intro.title,
    subtitle1: item.intro.subtitle1,
    subtitle2: item.intro.subtitle2,
    image: item.intro.image,
    statistics: item.statistics,
    backgroundColor: item.background_color,
  }));
};

export default mapStrategyListFromApi;
